import { createActionType } from '../../helpers'

export const LOAD_RECENTS = createActionType('RECENT_TOPICS', 'LOAD')
export const ADD_RECENT = createActionType('RECENT_TOPICS', 'ADD')
